import { resolveMinLimitOrderShares, MIN_MARKET_ORDER_USDC } from '@/constants/trade-order-limits';

/**
 * 校验下单最小金额/份额
 * @returns {{ ok: true } | { ok: false, code: 'belowMinMarketAmount' | 'belowMinLimitShares', min?: number }}
 */
export function validateTradeOrderMinLimits(order, pmProtocolVersion = '') {
  const isMarket = order?.orderType === 'market';
  const isSell =
    String(order?.side ?? '')
      .trim()
      .toLowerCase() === 'sell';

  // 仅 V2 限价卖出增加最低份额；市价卖出和旧协议保持原规则。
  if (isSell && (isMarket || pmProtocolVersion !== 'V2')) {
    return { ok: true };
  }

  if (isMarket) {
    const amount = Number(order?.amountDollars ?? 0);
    if (!Number.isFinite(amount) || amount < MIN_MARKET_ORDER_USDC) {
      return { ok: false, code: 'belowMinMarketAmount' };
    }
    return { ok: true };
  }

  const sellExact = Number(order?.sellQuantityExact ?? 0);
  const shares =
    isSell && Number.isFinite(sellExact) && sellExact > 0 ? sellExact : Number(order?.shares ?? 0);
  const min = resolveMinLimitOrderShares(pmProtocolVersion);
  if (!Number.isFinite(shares) || shares < min) {
    return { ok: false, code: 'belowMinLimitShares', min };
  }
  return { ok: true };
}
